export default __webpack_public_path__ + "static/media/LPT. COMUN.8beccdc3.pdf";